<resource-activity [resourceId]="(project$ | async)?.id"
                   [resourceType]="resourceType"
                   [workspace]="workspace$ | async">
</resource-activity>
